import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { DriveFileActions } from "@/features/files/drive-file-actions"
import { DriveFileViewer } from "@/features/files/drive-file-viewer"
import { driveQueries } from "@/queries/drive"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/files/$fileId/"
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(driveQueries.detail(params.fileId)),
  component: IndividualFilePage,
})

function IndividualFilePage() {
  const { fileId } = Route.useParams()
  const { data: file } = useSuspenseQuery(driveQueries.detail(fileId))

  return (
    <>
      <PageHeader
        title={file.name}
        actions={<DriveFileActions file={file} />}
      />
      <DriveFileViewer file={file} />
    </>
  )
}
